import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, Router } from '@angular/router';
import { TenantConfService } from './services/tenant-conf.service';

const routes: Routes = [
  {
    path: ':language',
    loadChildren: () => import('./main-router/main-router.module').then((m) => m.MainRouterPageModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      initialNavigation: 'enabledBlocking',
      useHash: false,
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'ignore',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(router: Router, tenantService: TenantConfService) {
    router.config.unshift({
      path: '',
      redirectTo: tenantService.getTenantDefaultLanguage(),
      pathMatch: 'full',
    });
  }
}
